<template>
  <div class="box is-shadowless">
    <div class="columns">
      <div class="column is-4 is-offset-4">
        <div class="card">
          <div class="card-content">
            <div class="level">
              <div class="level-left">
                <div class="level-item">
                  <p class="title is-4">SET NEW PASSWORD</p>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <b-button class="is-invisible"></b-button>
                </div>
              </div>
            </div>
            <form @submit.prevent="onSubmit">
              <b-field label="Email" v-if="!hasEmail">
                <b-input v-model="form.email" type="email"></b-input>
              </b-field>
              <b-field label="New Password">
                <b-input type="password" password-reveal v-model="form.password"></b-input>
              </b-field>
              <div class="level">
                <div class="level-left"></div>
                <div class="level-right">
                  <div class="level-item">
                    <div class="field">
                      <div class="control">
                        <button
                          :class="
                            `button is-dark ${loading ? 'is-loading' : ''}`
                          "
                        >SUBMIT</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthService } from "@/services/auth.service";

export default {
  data: () => ({
    authService: AuthService,
    form: {
      email: "",
      password: ""
    },
    hasEmail: false,
    loading: false
  }),
  mounted() {
    const email = this.$route.query.email;

    if (email) {
      this.hasEmail = true;
      this.form.email = email;
    }
  },
  methods: {
    transformedData() {
      return {
        token: this.$route.params.token,
        email_address: this.form.email,
        password: this.form.password,
        password_confirmation: this.form.password
      };
    },
    async onSubmit() {
      this.loading = true;

      try {
        await this.authService.resetPassword(this.transformedData());

        this.$buefy.toast.open({
          message: "New password has been set.",
          type: "is-info",
          position: "is-top-right"
        });

        const token = await this.authService
          .login({
            handle: this.form.email,
            password: this.form.password
          })
          .then(response => response.token);

        this.$store.dispatch("Auth/setToken", token);
        this.$router.replace("/");
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/PasswordReset/index.vue